"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
var SeoTags = function SeoTags(_ref) {
    var title = _ref.title, description = _ref.description, imageUrl = _ref.imageUrl, urlPath = _ref.urlPath, ogTitle = _ref.ogTitle;
    var shareTitle = ogTitle ? ogTitle : title;
    var metaTags = [{
            name: "twitter:card",
            content: "summary_large_image"
        }, {
            name: "twitter:site",
            content: "@priorclub"
        }, {
            property: "og:type",
            content: "website"
        }, {
            property: "og:url",
            content: "" + process.env.GATSBY_SITE_BASE_URL + urlPath
        }, {
            property: "fb:app_id",
            content: "" + process.env.GATSBY_FACEBOOK_APP_ID
        }, {
            name: "p:domain_verify",
            content: "d2c9dc6b23cd9aee6f3e5f0dbb77dc2a"
        }];
    description && metaTags.push({
        name: "description",
        content: description
    });
    description && metaTags.push({
        name: "twitter:description",
        content: description
    });
    description && metaTags.push({
        property: "og:description",
        content: description
    });
    imageUrl && metaTags.push({
        property: "og:image",
        content: imageUrl + "?w=640&h=640&fm=jpg&q=75"
    });
    imageUrl && metaTags.push({
        name: "twitter:image",
        content: imageUrl
    });
    shareTitle && metaTags.push({
        name: "twitter:title",
        content: shareTitle
    });
    shareTitle && metaTags.push({
        property: "og:title",
        content: "" + shareTitle
    });
    return /*#__PURE__*/ react_1.default.createElement(react_helmet_1.Helmet, {
        htmlAttributes: {
            lang: "en"
        },
        title: title,
        meta: metaTags
    });
};
exports.default = SeoTags;
